/* CS3D theme helpers: dispatch countdown, tabs, filament finder, colour swatch label, sticky add-to-cart */
(function () {
  'use strict';

  /* ---------- Dispatch countdown (10am AWST, Sunday–Thursday) ---------- */
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function perthNow() {
    // Perth is UTC+8 all year (no daylight saving)
    var now = new Date();
    return new Date(now.getTime() + now.getTimezoneOffset() * 60000 + 8 * 3600000);
  }

  function dispatchInfo(cutoffHour, days) {
    var p = perthNow();
    var day = p.getDay();
    var cutoff = new Date(p.getTime());
    cutoff.setHours(cutoffHour, 0, 0, 0);
    if (days.indexOf(day) !== -1 && p < cutoff) {
      var mins = Math.max(1, Math.floor((cutoff - p) / 60000));
      return { today: true, h: Math.floor(mins / 60), m: mins % 60 };
    }
    for (var i = 1; i <= 7; i++) {
      var d = (day + i) % 7;
      if (days.indexOf(d) !== -1) return { today: false, next: i === 1 ? 'tomorrow' : DAY_NAMES[d] };
    }
    return { today: false, next: '' };
  }

  function renderCountdowns() {
    var els = document.querySelectorAll('[data-cs3d-countdown]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var hour = parseInt(el.getAttribute('data-cutoff') || '10', 10);
      var days = (el.getAttribute('data-days') || '0,1,2,3,4').split(',').map(function (n) { return parseInt(n, 10); });
      var info = dispatchInfo(hour, days);
      var todayTpl = el.getAttribute('data-today') || 'Order in [time] for same-day dispatch';
      var laterTpl = el.getAttribute('data-later') || 'Order now for dispatch [day]';
      if (info.today) {
        var t = (info.h > 0 ? info.h + 'h ' : '') + info.m + 'm';
        el.innerHTML = escapeHtml(todayTpl).replace('[time]', '<strong class="cs3d-countdown__time">' + t + '</strong>');
      } else {
        el.textContent = laterTpl.replace('[day]', info.next);
      }
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Tabs (filament finder + product details) ---------- */
  function initTabs(root) {
    var groups = (root || document).querySelectorAll('[data-cs3d-tabs]:not([data-ready])');
    Array.prototype.forEach.call(groups, function (group) {
      group.setAttribute('data-ready', '');
      var tabs = group.querySelectorAll('[role="tab"]');
      var panels = group.querySelectorAll('[role="tabpanel"]');
      function select(i, focus) {
        Array.prototype.forEach.call(tabs, function (t, j) {
          var on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          if (on && focus) t.focus();
        });
        Array.prototype.forEach.call(panels, function (p, j) { p.hidden = i !== j; });
      }
      Array.prototype.forEach.call(tabs, function (t, i) {
        t.addEventListener('click', function () { select(i, false); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          if (n !== null) { e.preventDefault(); select(n, true); }
        });
      });
      select(0, false);
    });
  }

  /* ---------- Colour swatch: show selected name in legend ---------- */
  function initSwatchLabels() {
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      var fs = input.closest('.cs3d-swatches');
      if (!fs) return;
      var out = fs.querySelector('[data-swatch-selected]');
      if (out) out.textContent = input.value;
    });
  }

  /* ---------- Volume tiers: set quantity ---------- */
  function initTiers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cs3d-tier]') : null;
      if (!btn) return;
      var wrap = btn.closest('[data-cs3d-tiers]');
      var qty = parseInt(btn.getAttribute('data-cs3d-tier'), 10) || 1;
      Array.prototype.forEach.call(wrap.querySelectorAll('[data-cs3d-tier]'), function (b) {
        b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
      });
      var section = btn.closest('section, .shopify-section') || document;
      var input = section.querySelector('quantity-input input[name="quantity"], input.quantity__input');
      if (input) {
        input.value = qty;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-cs3d-sticky]');
    if (!bar) return;
    var mainBtn = document.querySelector('product-info .product-form__submit, .product__info-wrapper .product-form__submit');
    if (!mainBtn) { bar.remove(); return; }
    var stickyBtn = bar.querySelector('[data-sticky-add]');
    var variantOut = bar.querySelector('[data-sticky-variant]');
    var priceOut = bar.querySelector('[data-sticky-price]');

    function sync() {
      var picker = document.querySelector('variant-radios, variant-selects');
      if (picker && variantOut) {
        var vals = [];
        picker.querySelectorAll('input[type="radio"]:checked, select').forEach(function (el) { vals.push(el.value); });
        if (vals.length) variantOut.textContent = vals.join(' · ');
      }
      var price = document.querySelector('.product__info-wrapper .price__regular .price-item--regular, .product__info-wrapper .price .price-item');
      var sale = document.querySelector('.product__info-wrapper .price--on-sale .price-item--sale');
      if (priceOut && (sale || price)) priceOut.textContent = (sale || price).textContent.trim();
      if (stickyBtn) {
        stickyBtn.disabled = mainBtn.disabled;
        stickyBtn.textContent = mainBtn.disabled ? (mainBtn.textContent.trim() || 'Sold out') : stickyBtn.getAttribute('data-label');
      }
    }

    stickyBtn && stickyBtn.addEventListener('click', function () { mainBtn.click(); });
    document.addEventListener('change', function () { setTimeout(sync, 400); });
    sync();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        bar.classList.toggle('is-visible', !visible && entries[0].boundingClientRect.top < 0);
      }).observe(mainBtn);
    }
  }

  function init() {
    renderCountdowns();
    setInterval(renderCountdowns, 30000);
    initTabs();
    initSwatchLabels();
    initTiers();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-initialise inside the theme editor when sections reload
  document.addEventListener('shopify:section:load', function (e) { initTabs(e.target); renderCountdowns(); });
})();
